var SupportMultipleQtyPopupView, SupportServiceActionButtonTemplate, SupportServiceActionsBaseView, SupportViewVoucherServiceActionView,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SupportServiceActionsBaseView = require('./service_action_base');

SupportServiceActionButtonTemplate = require('../../../../service_action_button.html.mustache');

SupportMultipleQtyPopupView = require('../../multiple_Qty_Popup_View');

SupportViewVoucherServiceActionView = (function(superClass) {
  extend(SupportViewVoucherServiceActionView, superClass);

  function SupportViewVoucherServiceActionView() {
    return SupportViewVoucherServiceActionView.__super__.constructor.apply(this, arguments);
  }

  SupportViewVoucherServiceActionView.prototype.initialize = function() {
    _.bindAll.apply(_, [this].concat(_.functions(this)));
    this.I18nScope = 'modules.support';
    this.template = SupportServiceActionButtonTemplate;
    return this.order = Groupon.Support.currentOrder;
  };

  SupportViewVoucherServiceActionView.prototype.render = function() {
    this.$el.append(toHtml(this.template, this.toHash(), this.I18nScope));
    if (!this.shouldShowPopup()) {
      return this.addHref(this.getUrlForVoucher(this.order.groupons[0]));
    }
  };

  SupportViewVoucherServiceActionView.prototype.toHash = function() {
    var button_title, hash;
    button_title = this.isSingleGroupon() ? this.getSingleActionTitle() : this.getMultipleItemTitle();
    hash = {
      service_action_id: "view_voucher"
    };
    if (this.isSingleGroupon()) {
      hash.service_action = I18n.t("js.modules.support.view_voucher");
      this.extendSingleGrouponParams(hash);
    } else {
      hash.service_action = I18n.t("js.modules.support.view_vouchers");
    }
    return this.extendHash(hash);
  };

  SupportViewVoucherServiceActionView.prototype.actionHandler = function(event) {
    var args, current_order, multipleQtyPopup;
    current_order = Groupon.Support.currentOrder;
    if (this.shouldShowPopup()) {
      args = {
        orders: this.order,
        serviceActionName: 'view_voucher',
        singleActionButtonCallback: this.getUrlForVoucher,
        groupActionButtonCallback: this.getUrlForAllVouchers,
        showgroupActionButton: !this.isSingleGroupon(),
        title: this.getMultipleItemTitle(),
        singleActionButtonName: this.getSingleActionTitle(),
        groupActionButtonName: this.getGroupActionTitle(),
        showAlertMessage: this.shouldShowAlertMessage(),
        alertMessage: I18n.t("js.modules.support.view_voucher_warning")
      };
      multipleQtyPopup = new SupportMultipleQtyPopupView(args);
      multipleQtyPopup.render();
    }
    return true;
  };

  SupportViewVoucherServiceActionView.prototype.getMultipleItemTitle = function() {
    return I18n.t("js.modules.support.view_vouchers");
  };

  SupportViewVoucherServiceActionView.prototype.getSingleActionTitle = function() {
    return I18n.t("js.modules.support.view_voucher");
  };

  SupportViewVoucherServiceActionView.prototype.getGroupActionTitle = function() {
    return I18n.t("js.modules.support.view_all_vouchers");
  };

  SupportViewVoucherServiceActionView.prototype.shouldShowPopup = function() {
    return (!this.isSingleGroupon()) || this.shouldShowAlertMessage();
  };

  SupportViewVoucherServiceActionView.prototype.shouldShowAlertMessage = function() {
    return this.order && evaluate(this.order.isEditable);
  };

  SupportViewVoucherServiceActionView.prototype.getUrlForAllVouchers = function(order_id) {
    var url;
    url = "/users/" + currentUser.id + "/vouchers/print.pdf?order_id=" + order_id;
    return url;
  };

  SupportViewVoucherServiceActionView.prototype.getUrlForVoucher = function(groupon) {
    var url;
    if (window.isIntl()) {
      url = groupon.voucherUrl;
    } else if (window.isNeedish()) {
      url = groupon.voucherUrl || ("/users/" + currentUser.id + "/vouchers/" + groupon.redemptionCode + ".pdf");
    } else {
      url = "/users/" + currentUser.id + "/vouchers/" + groupon.id + ".pdf";
    }
    return url;
  };

  SupportViewVoucherServiceActionView.prototype.addHref = function(url) {
    return this.$el.find('#view_voucher').attr('href', url);
  };

  SupportViewVoucherServiceActionView.prototype.renderErrorPage = function() {
    return flash('error', "Error when contacting server for Voucher PDF");
  };

  SupportViewVoucherServiceActionView.prototype.events = {
    "click #view_voucher": "actionHandler"
  };

  return SupportViewVoucherServiceActionView;

})(SupportServiceActionsBaseView);

module.exports = SupportViewVoucherServiceActionView;

//# sourceMappingURL=data:application/json;base64,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
